import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SettingsChangePrinterPaperSizesPage } from 'src/app/modals/settings-change-printer-paper-sizes/settings-change-printer-paper-sizes.page';

const routes: Routes = [
  {
    path: '',
        component: SettingsChangePrinterPaperSizesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
    declarations: [SettingsChangePrinterPaperSizesPage]
})
export class SettingsChangePrinterPaperSizesPageModule {}
